import React from "react";
import { Card } from "flowbite-react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import Enderecos from "../../common/query/Enderecos";
import Emails from "../../common/query/Emails";
import Telefones from "../../common/query/Telefones";

const LocalizacaoPFQuery = ({ data }) => {
  return (
    <div className="space-y-10 mt-8">
      <div>
        <TitleStripe>👤 Dados Cadastrais</TitleStripe>
        <div className="mt-4 p-4 border border-gray-200 rounded-md">
          <div className="grid grid-cols-2 gap-8 text-sm text-gray-800">
            <div className="space-y-4">
              <div>
                <p className="text-gray-500 text-xs uppercase">Nome completo</p>
                <p className="text-base font-semibold">
                  {data?.nome || "Indisponível"}
                </p>
              </div>
              <div>
                <p className="text-gray-500 text-xs uppercase">Nome da mãe</p>
                <p>{data?.nomeMae || "Indisponível"}</p>
              </div>
              <div>
                <p className="text-gray-500 text-xs uppercase">
                  Data de nascimento
                </p>
                <p>{data?.dataNascimento || "Indisponível"}</p>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <p className="text-gray-500 text-xs uppercase">CPF</p>
                <p className="text-base font-semibold">
                  {data?.cpf || "Indisponível"}
                </p>
              </div>
              <div>
                <p className="text-gray-500 text-xs uppercase">Situação</p>
                <span
                  className={`inline-block px-3 py-1 text-xs font-bold rounded-full ${
                    data?.situacao?.toUpperCase() === "REGULAR"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {data?.situacao || "Indisponível"}
                </span>
              </div>
              <div>
                <p className="text-gray-500 text-xs uppercase">Sexo</p>
                <p>{data?.sexo || "Indisponível"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PARTICIPAÇÃO EM EMPRESAS */}
      {data?.participacaoEmEmpresas && (
        <div>
          <TitleStripe>🏢 Participação em Empresas</TitleStripe>
          {data.participacaoEmEmpresas.length > 0 ? (
            <ParticipacaoEmEmpresas empresas={data.participacaoEmEmpresas} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {/* ENDEREÇOS */}
      {data?.enderecos && (
        <div>
          <TitleStripe>📍 Endereços</TitleStripe>
          {data.enderecos.length > 0 ? (
            <Enderecos enderecos={data.enderecos} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {/* EMAILS */}
      {data?.emails && (
        <div>
          <TitleStripe>📧 E-mails</TitleStripe>
          {data.emails.length > 0 ? (
            <Emails emails={data.emails} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {/* TELEFONES */}
      {data?.telefones && (
        <div>
          <TitleStripe>📞 Telefones</TitleStripe>
          {data.telefones.length > 0 ? (
            <Telefones telefones={data.telefones} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}
    </div>
  );
};

export default LocalizacaoPFQuery;
